// Scroll-hide logic is now merged into FeatureNav.tsx.
// This stub prevents import errors. Safe to remove entirely. We can remove this component later
const HeaderComponent = () => null;
export default HeaderComponent;
